import { useTranslate } from "ra-core";

import { Isotipo } from "../tema/Isotipo";

/**
 * Panel negro de marca que acompaña a las pantallas de acceso en escritorio.
 * Marca (Core 5.0): negro #0A0A0A, isotipo en blanco, título en Albert Sans en
 * mayúsculas, descriptor en Inter.
 */
export const PanelMarca = () => {
  const translate = useTranslate();
  return (
    <div className="relative hidden h-full flex-col justify-between bg-[#0A0A0A] p-10 text-[#FAFAF7] lg:flex">
      <div className="flex items-center gap-3">
        <Isotipo tono="blanco" className="h-9" />
        <span className="font-marca uppercase tracking-[0.12em] text-xl font-medium">
          {translate("nevora.app.nombre")}
        </span>
      </div>
      <div className="space-y-3">
        <p className="etiqueta text-[#FAFAF7]/60">Nevora Consulting</p>
        <p className="font-display text-3xl font-light leading-snug tracking-[-0.01em] max-w-md">
          {translate("nevora.app.descriptor")}
        </p>
      </div>
    </div>
  );
};
